import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from 'react-zoom-pan-pinch'
import { useState } from 'react'
import moment from 'moment'
import { trimText } from '../../utils/Helper'
import { VideoPreviewIcon } from '../../components/common/icons/VideoPreviewIcon'
import { SoundPreviewIcon } from '../../components/common/icons/SoundPreviewIcon'

const RenderAsset = ({ url, type }) => {
  if (type === 'video') {
    return (
      <div className="audio-video-bg lg">
        <VideoPreviewIcon />
        <p>Video</p>
      </div>
    )
  } else if (type === 'image') {
    return <img src={url} alt="asset" />
  } else if (type === 'audio') {
    return (
      <div className="audio-video-bg lg">
        <SoundPreviewIcon />
        <p>Audio</p>
      </div>
    )
  }
}

const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls()

  return (
    <div className="zoom-tools">
      <button onClick={() => zoomIn()}>+</button>
      <button onClick={() => resetTransform()}>Fit</button>
      <button onClick={() => zoomOut()}>-</button>
    </div>
  )
}

const VerifyViewPage = ({ verifiedData }) => {
  const [showProcessContent, setShowProcessContent] = useState(true)

  const toggleProcessContent = () => {
    setShowProcessContent((prev) => !prev)
  }

  return (
    <div className="verify-view-section">
      <div className="verify-view-section__content">
        <div className="files-credentials-section"></div>
        <div className="files-view-section">
          <div className="content">
            <TransformWrapper
              initialScale={1}
              limitToBounds={false}
              minScale={0.2}
              centerOnInit={false}
              centerZoomedOut={false}
              centerZoomedIn={false}>
              {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                <>
                  <TransformComponent
                    wrapperStyle={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    contentStyle={{}}>
                    <div className="content-img">
                      {/* <img src={verifiedData.url} alt="file" /> */}
                      <RenderAsset
                        url={verifiedData.url}
                        type={verifiedData.fileType}
                      />
                    </div>
                  </TransformComponent>
                  <Controls />
                </>
              )}
            </TransformWrapper>
          </div>
        </div>
        <div className="files-detail-section">
          <div className="content">
            <div className="title">
              {verifiedData.assetTitle && (
                <p>
                  <b>{trimText(verifiedData.assetTitle, 20)}</b>
                </p>
              )}
              {verifiedData.signedTime && (
                <p>
                  {trimText(`Issued by ${verifiedData.appUsed} on
                  ${moment(verifiedData.signedTime).format('MMM D, YYYY')}`)}
                </p>
              )}
            </div>
            <div className="file">
              {/* <img src={verifiedData.url} alt="file" /> */}
              <RenderAsset
                url={verifiedData.url}
                type={verifiedData.fileType}
              />
            </div>
            <div className="line-demarcator"></div>
            <div className="content-summary">
              <p className="summary-title">
                <b>Content summary</b>
              </p>
              <p className="summary-content">
                <FontAwesomeIcon icon={faInfoCircle} color="gray" />{' '}
                {verifiedData.assetSummary}
              </p>
            </div>
            <div className="line-demarcator"></div>
            <div
              className={`content-process${
                !showProcessContent ? ' hide-content' : ''
              }`}>
              <p className="process-title" onClick={toggleProcessContent}>
                <span>
                  <b>Process</b>
                </span>
                <span>
                  {' '}
                  <FontAwesomeIcon icon={faCaretDown} color="gray" />{' '}
                </span>
              </p>
              <p>
                The app or device used to produce this content recorded the
                following info:
              </p>
              <p style={{ marginTop: 10 }}>
                <b>App or device used</b>
              </p>
              <p>{verifiedData.appUsed}</p>
              <p style={{ marginTop: 10 }}>
                <b>AI tool used</b>
              </p>
              <p>{verifiedData.aiTool}</p>
              {verifiedData && (
                <>
                  <p style={{ marginTop: 10, fontSize: 16 }}>
                    <b>License</b>
                  </p>
                  <ul>
                    <li>
                      <b>Name</b>: {verifiedData.name?.toUpperCase()}
                    </li>
                    <li>
                      <b>Assignment</b>: {verifiedData.assign?.toUpperCase()}
                    </li>
                    <li>
                      <b>License</b>: {verifiedData.license?.toUpperCase()}
                    </li>
                    <li>
                      <b>Royalty</b>: {verifiedData.royalty?.toUpperCase()}
                    </li>
                    <li>
                      <b>Ref</b>: {verifiedData.ref}
                    </li>
                    {verifiedData?.verifyUrl && (
                      <a
                        style={{
                          textDecoration: 'underline',
                          color: '#0daa85',
                          fontWeight: 'bold',
                          fontSize: 12,
                        }}
                        href={verifiedData.verifyUrl}>
                        Login or Register to view more
                      </a>
                    )}
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyViewPage
